
export { CloseIcon } from "/vercel/path0/libs/icons/src/lib/CloseIcon.tsx"